export default function createFooter() {
	return "";
}